var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 59,
    viewBox: "0 0 43 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8006 34.9548V39.3555L16.2837 40.2097V35.809L12.8006 34.9548ZM29.483 27.2446V31.5185H38.4084V41.2403L20.5604 36.8589V41.2596L22.8833 41.83H38.4111V36.148V31.5185H29.4858V27.2446M8.53217 19.7439L0.697998 21.6673V36.3822L8.53217 38.3056V33.9049L4.97193 33.0314V25.0208L8.53217 24.1473V19.7466M16.2892 17.8425L12.8061 18.6967V23.0974L16.2892 22.2432V17.8425ZM38.4111 16.225H22.8833L20.5604 16.7954V21.1961L38.4084 16.8147V21.907V16.225",
    fill: "#F7B6A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.205 11.951H20.5574V16.225H22.8803L34.2665 13.428L31.205 11.951Z",
    fill: "#BCDCDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2668 13.428L22.8806 16.225H38.4084V21.9043H42.6796H38.4084V15.4286L34.2668 13.428Z",
    fill: "#BEC4BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5293 38.3056V46.1012H16.2863V41.8273H12.8032V39.3527L8.5293 38.3028M12.8032 23.0947L8.5293 24.1446V33.9049L12.8032 34.9548V23.0974M16.2863 11.951H8.5293V19.7466L12.8032 18.6967V16.2222H16.2863V11.9483",
    fill: "#BCDCDF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5293 33.9077V38.3084L12.8032 39.3582V34.9575L8.5293 33.9077ZM12.8032 18.6995L8.5293 19.7494V24.1501L12.8032 23.1002V18.6995Z",
    fill: "#BEC4BE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8803 41.83H20.5574V46.1039H31.7286L34.4924 44.6793L22.8803 41.83Z",
    fill: "#BCDCDF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4084 36.148V41.83H22.8806L34.4927 44.6793L38.4084 42.6622V36.148Z",
    fill: "#BEC4BE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2864 0V11.951H20.5576V6.80909L31.2052 11.951H40.2877L40.7809 11.8298L41.0344 11.951L42.6795 12.7474V21.9043V12.7474L41.0344 11.951L40.7809 11.8298L16.2864 0Z",
    fill: "#9DB9C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7809 11.8298L40.2876 11.951H41.0344L40.7809 11.8298Z",
    fill: "#9FA2A9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2864 40.2097V41.83H20.5603V41.2596L16.2864 40.2097ZM20.5603 21.1933L16.2864 22.2432V35.8118L20.5603 36.8617V21.1961M20.5603 16.225H16.2864V17.8425L20.5603 16.7926V16.2222",
    fill: "#9DB9C8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2864 35.8118V40.2125L20.5603 41.2624V36.8617L16.2864 35.8118ZM20.5603 16.7954L16.2864 17.8453V22.246L20.5603 21.1961V16.7954Z",
    fill: "#9FA2A9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2877 46.1039H31.7288L20.5576 51.8576V46.1039H16.2864V58.8651L40.8112 46.2307L40.2877 46.1039Z",
    fill: "#9DB9C8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0619 46.1039H40.2876L40.8112 46.2307L41.0619 46.1039Z",
    fill: "#9FA2A9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2878 11.951H31.2053L34.2668 13.428L40.2878 11.951Z",
    fill: "#7DADBC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0344 11.951H40.2876L34.2666 13.428L38.4083 15.4286V21.9043H42.6794V12.7474L41.0344 11.951Z",
    fill: "#7FA4AF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4927 44.6793L31.7316 46.1012H40.2877L34.4927 44.6793ZM20.5576 11.951H16.2837V16.225H20.5576V11.951Z",
    fill: "#7DADBC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6796 36.148H38.4084V42.6622L34.4927 44.6793L40.2877 46.1039H41.062L42.6796 45.269V36.148Z",
    fill: "#7FA4AF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5576 41.83H16.2864V46.1039H20.5576V41.83Z",
    fill: "#7DADBC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6797 27.2474H29.4832V31.5185H38.4085V36.148H42.6797V27.2474Z",
    fill: "#7FA4AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLogo);
export default __webpack_public_path__ + "static/media/short_logo.ea81b430b13df13510606f93c9b53416.svg";
export { ForwardRef as ReactComponent };